import { render, staticRenderFns } from "./task_page.vue?vue&type=template&id=7f7327b2&scoped=true"
import script from "./task_page.vue?vue&type=script&lang=js"
export * from "./task_page.vue?vue&type=script&lang=js"
import style0 from "./task_page.vue?vue&type=style&index=0&id=7f7327b2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7327b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f7327b2')) {
      api.createRecord('7f7327b2', component.options)
    } else {
      api.reload('7f7327b2', component.options)
    }
    module.hot.accept("./task_page.vue?vue&type=template&id=7f7327b2&scoped=true", function () {
      api.rerender('7f7327b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/grow/task_page.vue"
export default component.exports